<template lang="html">
  <p>loading...</p>
</template>

<script>
export default {
  created() {
    if (this.$route.params.selected_type === 'reservation') {
      this.$store.dispatch('saveSelectedType', 'RESERVATION')
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    } else if (this.$route.params.selected_type === 'takeaway') {
      this.$store.dispatch('saveSelectedType', 'OL-TAKE-AWAY')
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    } else if (this.$route.params.selected_type === 'delivery') {
      this.$store.dispatch('saveSelectedType', 'DELIVERY')
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    } else if (this.$route.params.selected_type === 'dinein') {
      this.$store.dispatch('saveSelectedType', 'DINE-IN')
      this.$router.push({ name: 'listoutlets' }).catch(() => {})
    } else {
      this.$store.dispatch('saveSelectedType', '')
      this.$router.push({ name: 'home' }).catch(() => {})
    }
  }
}
</script>
